/* eslint-disable prettier/prettier */
/* eslint-disable no-debugger */
import React, { useEffect, useRef, useState } from "react";
import { IBreadcrumb } from "../../../model/interface/breadcrumb";
import constant from "../../../utils/constant";
import Breadcrumb from "../../shared/common/breadcrumb";
import Select from "react-select";
import { getStateAll } from "../../../api/subject.service";
import {
  getDistrictRosterConnectionCounts,
  deleteDistrictRosterConnections,
  getMiniCRMDistricts,
  syncDistrict,
  updateDistrict,
} from "../../../api/miniCrm.service";
import { connect } from "react-redux";
import Loader from "../../shared/loader/loader";
import { toast } from "react-toastify";
import {
  DistrictSchoolList,
  IDistrictSchoolListHandle,
} from "./districtSchoolList";
import { IRosterConnectionCounts } from "../../../model/interface/districts";
import { ConfirmDeleteRosterConnections } from "./Popup/ConfirmDeleteRosterConnections";
import { useNumericParam } from "../../../utils/useNumericParam";
import Constant from "../../../utils/constant";
import Permissions from "../../../utils/permissions";
import { userPermissions } from "../../shared/common/rbac";

function DistrictDetail(props: any) {
  const id = useNumericParam("id");
  const districtId = id ? id : 0;
  const [states, setStates] = useState<Array<any>>([]);
  const [district, setDistrict] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [invalidNWEAId, setInvalidNWEAId] = useState(false);
  const [showSyncButton, setShowSyncButton] = useState(false);
  const [hasCleverId, setHasCleverId] = useState(false);
  const [hasClasslinkId, setHasClasslinkId] = useState(false);
  const [rosterConnectionCounts, setRosterConnectionCounts] = useState<
    Array<IRosterConnectionCounts>
  >([]);
  const [hasRosteredUsers, setHasRosteredUsers] = useState<boolean>(false);
  const schoolListRef = useRef<IDistrictSchoolListHandle>(null);
  const [
    showDeleteRosterConnectionsDialog,
    setShowDeleteRosterConnectionsDialog,
  ] = useState<boolean>(false);
  const regex =
    /^([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})|[0-9]+$/i;

  const breadcrumbItems = () => {
    const items: Array<IBreadcrumb> = [
      {
        name: "CRM",
        url: constant.CRM,
        state: { crmType: constant.CRM_TYPE.DISTRICT },
      },
      {
        name: "District Details",
        url: "",
      },
    ];
    return items;
  };
  async function getDistrictDetails(districtId: number, statesObj: any = []) {
    statesObj =
      statesObj === null || statesObj.length === 0 ? states : statesObj;
    const resp = await getMiniCRMDistricts({
      region: "",
      districtId: districtId,
      districtName: "",
      orderByColumn: "",
      sortDir: "",
      pageSize: 9999,
      pageNumber: 1,
    });

    if (resp && resp.data && resp.data.data && resp.data.data.length > 0) {
      const districtObj = resp.data.data[0];
      const state = statesObj.find(
        (s) => s.value === resp.data.data[0].stateId
      );
      districtObj.stateId = state;
      setDistrict(districtObj);
      setHasCleverId(districtObj?.cleverId && districtObj.cleverId !== "");
      setHasClasslinkId(
        districtObj?.classlinkId && districtObj.classlinkId !== ""
      );
      setLoading(false);
      setShowSyncButton(districtObj?.cleverId || districtObj?.classlinkId);
    }
    setLoading(false);
  }
  const getRosteredUserCounts = async () => {
    const response = await getDistrictRosterConnectionCounts(districtId);
    if (response) {
      console.log("counts", response.data);
      setRosterConnectionCounts(response.data);
    }
  };

  const getStates = async () => {
    setLoading(true);
    const resp: any = await getStateAll(9999, 1);
    if (resp && resp.data) {
      const statesObj = resp?.data?.data?.map((ds) => ({
        label: ds.name,
        value: ds.stateId,
      }));
      setStates(statesObj);
      await getDistrictDetails(districtId, statesObj);
    }
  };

  const loadDistrictData = async () => {
    await getStates();
    await getRosteredUserCounts().catch((e) => {
      if (e.response?.status === 403) {
        console.info(
          "403 error while fetching roster connection counts, user does not have permission to view this data"
        );
      } else {
        throw e;
      }
    });
  };

  const update = async () => {
    if (district?.nweaId) {
      if (!district?.nweaId.match(regex)) {
        setInvalidNWEAId(true);
        return false;
      }
    }

    if (district?.cleverId && district?.classlinkId) {
      toast.error(
        "District can not have both clever and classlink enabled. Please set either clever or classlink."
      );
      return false;
    }

    setInvalidNWEAId(false);
    setLoading(true);
    try {
      updateDistrict({
        stateId: district?.stateId.value,
        name: district?.name,
        districtId: district?.districtId,
        city: district?.city,
        zipCode: district?.zipCode,
        cleverId: district?.cleverId,
        updatedByUser: props?.profile?.userId,
        nweaId: district?.nweaId === "" ? null : district?.nweaId,
        classlinkId: district?.classlinkId,
        cleverLmsConnectTypeId: district?.cleverLmsConnectTypeId,
        isRosterActive: district?.isRosterActive,
        proctorModeEnabled: !!district?.proctorModeEnabled,
      }).then((resp) => {
        if (resp.data) {
          if (resp.data.success === true) {
            toast.success("District updated successfully");
            getStates();
            setLoading(false);
          } else {
            toast.error(resp.data.message);
          }
        }
      });
    } catch (e) {
      toast.error("District update failed");
      console.log(e);
      setLoading(false);
    }
  };

  const forceSyncDistrict = () => {
    syncDistrict({
      DistrictId: districtId,
    }).then(() => {
      toast.info("District sync started");
    });
  };

  const handleConfirmDeleteRosterConnectionsConfirmClick = async (
    externalRosterProviderId: number
  ) => {
    setLoading(true);
    try {
      await deleteDistrictRosterConnections(
        districtId,
        externalRosterProviderId
      );
      toast.success(
        "District user and class roster connections deleted successfully"
      );

      await loadDistrictData();
      //Force the schools table to refetch as well
      schoolListRef.current?.refresh();
    } catch (e) {
      toast.error(
        "An error occurred while attempting to delete user and class roster connections"
      );
    } finally {
      setLoading(false);
      setShowDeleteRosterConnectionsDialog(false);
    }

    console.log("Unlinking", externalRosterProviderId);
  };

  useEffect(() => {
    loadDistrictData();
  }, [districtId]);

  useEffect(() => {
    const total = rosterConnectionCounts.filter(
      (ruc) =>
        (ruc.externalRosterProviderId === 1 ||
          ruc.externalRosterProviderId === 2) &&
        (ruc.userCount > 0 || ruc.classCount > 0)
    );
    setHasRosteredUsers(total.length > 0);
  }, [rosterConnectionCounts]);

  const getRosterActiveToggle = () => {
    return (
      <label
        htmlFor="chkRosterEnabled"
        className="flex items-center cursor-pointer pl-1 mt-2 grid grid-cols-4"
      >
        <div className="mr-2 text-gray-700 font-medium">
          {district.isRosterActive ? "Active" : "Inactive"}
        </div>
        <div className="relative">
          <input
            id="chkRosterEnabled"
            type="checkbox"
            value={1}
            className="sr-only"
            checked={district.isRosterActive}
            onChange={(e) =>
              setDistrict({
                ...district,
                isRosterActive: e.target.checked,
              })
            }
          />
          <div
            className={`${
              district.isRosterActive ? "bg-primary-color " : "bg-gray-300 "
            } w-12 h-7 rounded-full shadow-inner`}
          ></div>
          <div
            className={`${
              district.isRosterActive ? "toggle-btn" : ""
            } absolute w-5 h-5 bg-white rounded-full shadow left-1 top-1 transition`}
          ></div>
        </div>
        <div></div>
        <div></div>
      </label>
    );
  };
  return (
    <>
      {showDeleteRosterConnectionsDialog && (
        <ConfirmDeleteRosterConnections
          rosterConnectionCounts={rosterConnectionCounts}
          onCancel={() => setShowDeleteRosterConnectionsDialog(false)}
          onConfirm={handleConfirmDeleteRosterConnectionsConfirmClick}
        ></ConfirmDeleteRosterConnections>
      )}
      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 overflow-y-auto mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">
                District Details
              </h3>
            </div>
            <Breadcrumb items={breadcrumbItems()} />
            <form>
              {loading && <Loader />}
              <div className="shadow border rounded-lg mt-4 px-4 py-6">
                <div>
                  <div className="mt-3 mb-5 grid grid-cols-3 gap-4">
                    <div>
                      <span className="whitespace-nowrap text-gray-700">
                        District Name
                      </span>
                      <input
                        value={district.name}
                        onChange={(e) =>
                          setDistrict({ ...district, name: e.target.value })
                        }
                        type="text"
                        autoComplete="off"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-black sm:text-sm"
                      />
                    </div>

                    <div>
                      <label className="text-sm text-gray-700">State</label>
                      <Select
                        className="mt-1 text-sm"
                        value={district.stateId}
                        options={states}
                        onChange={(e) => {
                          setDistrict({ ...district, stateId: e });
                        }}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                      />
                    </div>

                    <div>
                      <span className="whitespace-nowrap text-gray-700">
                        City
                      </span>
                      <input
                        value={district.city}
                        onChange={(e) =>
                          setDistrict({ ...district, city: e.target.value })
                        }
                        type="text"
                        autoComplete="off"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-black sm:text-sm"
                      />
                    </div>

                    <div>
                      <span className="whitespace-nowrap text-gray-700">
                        Zip
                      </span>
                      <input
                        value={district.zipCode}
                        onChange={(e) =>
                          setDistrict({ ...district, zipCode: e.target.value })
                        }
                        type="text"
                        autoComplete="off"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-black sm:text-sm"
                      />
                    </div>
                  </div>
                  <div className="mt-3 border-t pt-5">
                    <h3 className="font-semibold text-gray-700">
                      District Settings
                    </h3>
                    <label
                      htmlFor="chkProctorModeEnabled"
                      className="flex items-center cursor-pointer pl-1 mt-3"
                    >
                      <div className="mr-2 text-gray-700">
                        Proctor Mode Enabled
                      </div>
                      <div className="relative">
                        <input
                          id="chkProctorModeEnabled"
                          type="checkbox"
                          className="sr-only"
                          checked={!!district.proctorModeEnabled}
                          onChange={(e) =>
                            setDistrict({
                              ...district,
                              proctorModeEnabled: e.target.checked,
                            })
                          }
                        />
                        <div
                          className={`${
                            district.proctorModeEnabled
                              ? "bg-primary-color "
                              : "bg-gray-300 "
                          } w-12 h-7 rounded-full shadow-inner`}
                        ></div>
                        <div
                          className={`${
                            district.proctorModeEnabled ? "toggle-btn" : ""
                          } absolute w-5 h-5 bg-white rounded-full shadow left-1 top-1 transition`}
                        ></div>
                      </div>
                    </label>
                  </div>
                  <div className="mt-3 border-t pt-5">
                    <h3 className="font-semibold text-gray-700">
                      External Rosters
                    </h3>
                    <div className="mt-3 grid grid-cols-3 gap-4">
                      <div>
                        <span className="whitespace-nowrap text-gray-700">
                          Clever Id
                        </span>
                        <input
                          value={district.cleverId ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            // PLP-5858: first-time ID entry (empty field + roster
                            // never configured, RosterUpdatedDate null) -> default Active.
                            const firstTime =
                              !district.cleverId &&
                              value &&
                              !district.rosterUpdatedDate;
                            setDistrict({
                              ...district,
                              cleverId: value,
                              isRosterActive: firstTime
                                ? true
                                : district.isRosterActive,
                            });
                          }}
                          type="text"
                          autoComplete="off"
                          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-black sm:text-sm"
                        />
                        {district.cleverId && getRosterActiveToggle()}
                      </div>
                      <div>
                        <span className="whitespace-nowrap text-gray-700">
                          Classlink Id
                        </span>
                        <input
                          value={district.classlinkId ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            // PLP-5858: first-time ID entry (empty field + roster
                            // never configured, RosterUpdatedDate null) -> default Active.
                            const firstTime =
                              !district.classlinkId &&
                              value &&
                              !district.rosterUpdatedDate;
                            setDistrict({
                              ...district,
                              classlinkId: value,
                              isRosterActive: firstTime
                                ? true
                                : district.isRosterActive,
                            });
                          }}
                          type="text"
                          autoComplete="off"
                          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-black sm:text-sm"
                        />
                        {district.classlinkId && getRosterActiveToggle()}
                      </div>
                      <div>
                        <span className="whitespace-nowrap text-gray-700">
                          Clever LMS Connect Type
                        </span>
                        <Select
                          value={
                            Constant.LMS_TYPES.find(
                              (o) => o.value === district.cleverLmsConnectTypeId
                            ) ?? null
                          }
                          options={Constant.LMS_TYPES}
                          isClearable={true}
                          isDisabled={
                            district.cleverId === null ||
                            district.cleverId === ""
                          }
                          onChange={(newValue) =>
                            setDistrict({
                              ...district,
                              cleverLmsConnectTypeId: newValue?.value,
                            })
                          }
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#B3B3B3",
                              primary: "#041E42",
                            },
                          })}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              background:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#1A1C23"
                                  : "white",
                              borderColor:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6B7280"
                                  : "#D1D5DB",
                              borderWidth: "1px",
                              "&:hover": {
                                borderColor:
                                  state.isFocused &&
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6b7280"
                                    : state.isFocused
                                    ? "#4c5563"
                                    : "",
                              },
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "white"
                                  : "#374051",
                            }),
                            input: (base) => ({
                              ...base,
                              color:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "white"
                                  : "",
                            }),
                          }}
                          className="mt-1 text-sm"
                        />
                        {invalidNWEAId && (
                          <span className="text-red-400 pt-1">
                            Please enter valid GUID
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-end pt-4">
                    {hasRosteredUsers &&
                      userPermissions().includes(
                        Permissions.district_delete
                      ) && (
                        <button
                          type="button"
                          onClick={() =>
                            setShowDeleteRosterConnectionsDialog(true)
                          }
                          className="mt-4 mr-4 w-64 text-center items-center text-sm rounded-lg text-white dark:text-black border border-gray-300 gap-2 bg-red-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                        >
                          <span>Disconnect Users From Roster...</span>
                        </button>
                      )}
                    {showSyncButton && (
                      <button
                        type="button"
                        onClick={forceSyncDistrict}
                        className="mt-4 mr-4 w-32 text-center items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                      >
                        <span>Force Sync</span>
                      </button>
                    )}
                    <button
                      type="button"
                      onClick={update}
                      className="mt-4 inline-flex items-center text-sm text-white dark:text-black gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
              <div className="shadow border rounded-lg mt-4 px-4 py-4">
                <h3 className="text-lg font-light text-gray-900">Schools</h3>
                <DistrictSchoolList
                  districtId={districtId}
                  hasCleverId={hasCleverId}
                  hasClasslinkId={hasClasslinkId}
                  userId={props?.profile?.userId}
                  setLoading={setLoading}
                  ref={schoolListRef}
                ></DistrictSchoolList>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(DistrictDetail);
